import angular from 'angular';
import EmployeeCard from '../employee-card/employee-card';
import employeeCardListComponent from './employee-card-list.component';

let employeeCardListModule = angular.module('employeeCardList', [
  EmployeeCard.name
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
})

.component('employeeCardList', employeeCardListComponent);

export default employeeCardListModule;



// WEBPACK FOOTER //
// ./client/pages/admin/project-details/components/employee-card-list/employee-card-list.js